import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navLinks, contactInfo } from "@/mocks/site";

const linkBase =
  "relative px-3 py-2 text-sm font-label transition-colors duration-200 whitespace-nowrap cursor-pointer";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-content items-center justify-between px-6 text-xs font-label">
          <p className="flex items-center gap-2 text-background-300">
            <i className="ri-shield-user-line text-sm" aria-hidden="true"></i>
            匿名投稿入口全天开放 · 信源信息默认脱敏
          </p>
          <p className="flex items-center gap-4 text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line text-sm" aria-hidden="true"></i>
              {contactInfo.email}
            </span>
            <span className="hidden lg:inline text-background-400">|</span>
            <span className="hidden lg:inline">先核实，再发布</span>
          </p>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-4 px-4 md:px-6">
          <Link to="/" className="flex items-center gap-3 cursor-pointer" aria-label="黑暗爆料 首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-background-50">
              <i className="ri-radar-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
                黑暗爆料
              </span>
              <span className="mt-0.5 text-[11px] font-label tracking-[0.2em] text-foreground-500">
                暗线 · 匿名爆料聚合
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  `${linkBase} ${
                    isActive
                      ? "font-semibold text-primary-700 after:absolute after:bottom-0 after:left-3 after:right-3 after:h-0.5 after:bg-primary-600"
                      : "text-foreground-700 hover:text-primary-700"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/submit"
              className="hidden items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-label font-medium text-background-50 transition-colors duration-200 hover:bg-primary-700 md:inline-flex whitespace-nowrap cursor-pointer"
            >
              <i className="ri-lock-line text-base" aria-hidden="true"></i>
              我要爆料
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 md:hidden" aria-label="移动端导航">
            <ul className="mx-auto max-w-content px-4 py-3">
              {navLinks.map((item) => (
                <li key={item.href}>
                  <NavLink
                    to={item.href}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center justify-between rounded-md px-3 py-3 text-sm font-label transition-colors cursor-pointer ${
                        isActive
                          ? "bg-primary-50 text-primary-700"
                          : "text-foreground-700 hover:bg-background-100"
                      }`
                    }
                  >
                    {item.name}
                    <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true"></i>
                  </NavLink>
                </li>
              ))}
              <li className="pt-2">
                <Link
                  to="/submit"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-3 text-sm font-label font-medium text-background-50 cursor-pointer"
                >
                  <i className="ri-lock-line text-base" aria-hidden="true"></i>
                  我要爆料
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}